import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { RotatingLines } from "react-loader-spinner";
import { markDefaultPrompt } from "../../services/promptService";

const PromptCell = ({ promptText }) => {
  const [showFullText, setShowFullText] = useState(false);

  const handleToggleText = () => {
    setShowFullText(!showFullText);
  };

  return (
    <div style={{ padding: "5px 0" }}>
      {showFullText || promptText.length <= 200 ? (
        promptText
      ) : (
        <>
          {promptText.substring(0, 200)}...
          <span
            onClick={handleToggleText}
            style={{
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
              marginLeft: "5px",
            }}
            title="Show more"
          >
            More
          </span>
        </>
      )}
      {showFullText && (
        <span
          onClick={handleToggleText}
          style={{
            color: "blue",
            cursor: "pointer",
            textDecoration: "underline",
            marginLeft: "5px",
          }}
          title="Show less"
        >
          Less
        </span>
      )}
    </div>
  );
};

const PromptsTable = ({
  data,
  pending,
  setIsOpen,
  setFunctionData,
  setOpenEdit,
  setEditData,
  totalRows,
  pageNumber,
  setPageNumber,
  setRowsPerPage,
  rowsPerPage,
}) => {
  const [defaultPrompt, setDefaultPrompt] = useState(null);

  const handleSetDefault = async (row) => {
    try {
      const updateUser = await markDefaultPrompt({ defaultPrompt: row?.id });
      setDefaultPrompt(row?.id);
      localStorage.setItem("defaultPromptNew", JSON.stringify(row));
    } catch (error) {
      console.error("Error setting default prompt:", error);
    }
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("defaultPromptNew"));

    if (data) {
      handleSetDefault(data);
    }
  }, []);

  const columns = [
    {
      name: "Name",
      selector: (row) => row.promptName,
      grow: 2,
    },
    {
      name: "Prompt",
      cell: (row) => <PromptCell promptText={row.promptText} />,
      grow: 5,
      wrap: true,
    },
    {
      name: "Set Default",
      grow: 2,
      cell: (row) => (
        <div class="check-box">
          <input
            type="checkbox"
            checked={defaultPrompt === row.id}
            onClick={(e) => {
              handleSetDefault(row);
            }}
          />
        </div>
      ),
      grow: 5,
      wrap: true,
    },
    {
      name: "Edit",
      cell: (row) => (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: 400,
            fontSize: 12,
          }}
          onClick={() => {
            setOpenEdit(true);
            setEditData(row);
          }}
        >
          <span
            style={{
              color: "#6E75FF",
              background: "#F3F3FF",
              padding: 5,
              borderRadius: 5,
              fontSize: 14,
            }}
          >
            <ion-icon name="create-sharp"></ion-icon>{" "}
          </span>
        </span>
      ),
      grow: 1,
      center: true,
      ignoreRowClick: true,
    },
    {
      name: "Delete",
      cell: (row) => (
        <span
          style={{ color: "#E13333", fontWeight: 400, fontSize: 15 }}
          onClick={() => {
            setIsOpen(true);
            setFunctionData({ type: "DELETE-PROMPT", data: row.id });
          }}
        >
          <ion-icon name="trash"></ion-icon>
        </span>
      ),
      grow: 1,
      center: true,
      ignoreRowClick: true,
    },
  ];

  return (
    <div style={{ position: "relative" }}>
      <DataTable
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
        onChangeRowsPerPage={setRowsPerPage}
        paginationDefaultPage={pageNumber}
        onChangePage={setPageNumber}
        title="Saved Prompts"
        pagination
        columns={columns}
        data={data}
        pointerOnHover
        highlightOnHover
        progressPending={pending}
        progressComponent={
          <div id="svg-container">
            <RotatingLines
              visible={true}
              height="96"
              width="96"
              color="red"
              strokeColor="grey"
              strokeWidth="4"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        }
        paginationServer
        paginationServerOptions={{
          persistSelectedOnPageChange: false,
          custom: true,
          totalRows: totalRows,
          totalPages: Math.ceil(totalRows / rowsPerPage),
        }}
        paginationTotalRows={totalRows}
      />
    </div>
  );
};

export default PromptsTable;
